module.exports = __webpack_public_path__ + "img/jm.b7b13124.svg";